__turbopack_context__.v({
  "icon": "OutboundTextLink-module__x9wsoq__icon",
  "label": "OutboundTextLink-module__x9wsoq__label",
  "root": "OutboundTextLink-module__x9wsoq__root",
});
